// extracted by mini-css-extract-plugin
module.exports = {"timeRange":"TimeRange_timeRange__vMQvI","time":"TimeRange_time__6uk7Q"};